import { useCallback, useEffect } from "react";

import { Element } from "@craftjs/core";

import { MidpathTCPAQuestionBlock } from "..";
import { define, prop, useCraftProp } from "../../utils";
import { useModuleMetadata } from "../../utils/tailwindConfig/hooks";
import BasePreview from "../base";

import { MidpathProvider, useMidpathContext } from "./context";
import pageOptions from "./pages-options.json";

function MidpathPreview() {
  const { page: { value: page, setValue: setPage } } = useMidpathContext()
  const pageId = useCraftProp('pageId')

  useModuleMetadata('session', true)

  useEffect(() => {
    const page = pageOptions.find(page => page.id === pageId.value)
    setPage(page)
  }, [pageId, setPage])

  if (page?.type) {
    const Component = {
      'tcpa-question': MidpathTCPAQuestionBlock,
    }[page.type]

    if (Component) {
      return <BasePreview>
        <div>
          <Element is={Component} id={`midpath-${page.id}`} />
        </div>
      </BasePreview>
    }
  }
  return <BasePreview>
    <div>Midpath</div>
  </BasePreview>
}

function MidpathHTML() {
  return <>
    <script type="text/javascript" src="{{@config.userEnrollHost}}/scripts/embed.js"></script>
    <script type="text/javascript" id="userenroll-embed" className="userenroll-embed" dangerouslySetInnerHTML={{
      __html: `(function (global) {
    function userenroll_load() {
      var data = {};
      data.siteId = '{{@session.meta.site_id}}';
      data.userSessionID = '{{@session.meta.uid}}'
      data.dnd_enabled = 'true';

      data.rurl = '/finish';
      data.duplicateUser = '{{@session.meta.duplicated}}';
      data.cf_reg_tcpa_confirm = '{{@session.meta.tcpa_consent}}';

      {{!-- {{#if (ne env "production")}} --}}
      data.embedUrlOverride = '{{@config.userEnrollHost}}';
      {{!-- {{/if}} --}}

      data.onPageLoad = function(props){
        var progress = {
          step: parseInt(props.currentPage) || 0,
          total: parseInt(props.totalPages) || 0,
        }

        document.dispatchEvent(new CustomEvent('update-progress-bar', { detail: { progress } }))
        localStorage.setItem("progress", JSON.stringify(progress))
      }

      global.userEnroll.initEmbed(data);
    }

    userenroll_load();
  })(this);`,
    }} />
  </>
}

export function usePageOptions() {
  return useCallback(async () => ({
    options: pageOptions.filter(page => page.id === 'tcpa-default').map(({ id, name }) => ({
      value: id,
      label: name,
    })),
  }), [])
}

export default define('midpath-preview', MidpathPreview, MidpathHTML)
  .wrap(({ children }) => <MidpathProvider>{children}</MidpathProvider>)
  .property(prop.select.async('Mode', 'pageId').category('default')
    .props({
      useOptions: usePageOptions,
    }).ignoreDevice().own())
  .defaultProps({
    pageId: 'tcpa-default',
  })
  .build()
